import { useNavigate, useSearchParams } from 'react-router-dom';
// import CloseIcon from "../Images/close-C.png"
import CloseIcon from "../Images/close.svg"
import { useState } from 'react';

const PDFViewer = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isHovered, setIsHovered] = useState(false);

    const pdfUrl = searchParams.get('pdf') || '';

    return (
        <>
            <div 
                style={{ 
                    position: "absolute", 
                    right: "160px", 
                    top: "12px", 
                    zIndex: 1000, 
                    width: "32px", 
                    height: "32px", 
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: isHovered ? "0 0 10px rgba(120,120,120,1)" : "none",
                    transition: "box-shadow 0.2s"
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <img src={CloseIcon} alt="Close" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => window.close()} />
            </div>
            <iframe
                id="PdfViewerFrame"
                title='Pdf Viewer'
                allowFullScreen
                src={pdfUrl}
                style={{ width: "100%", height: "900px", pointerEvents: "auto" }}
            />
        </>
    );
};
export default PDFViewer;